<template>
	<div>
			<!-- 搜索筛选 -->
			<!-- <el-form :inline="true" class="user-search" :model="formInline" size="small">
			<el-form-item label="现货代码">
				<el-select v-model="formInline.spotCode" placeholder="现货代码" clearable>
					<el-option :label="item" :value="item" v-for="(item,key) in spotCodes"
						:key="key">
					</el-option>
				</el-select>
			</el-form-item>

			<el-form-item label="期货代码">
				<el-select v-model="formInline.futuresCode" placeholder="选择期货代码" clearable>
					<el-option :label="item" :value="item" v-for="(item,key) in futureCodes"
						:key="key">
					</el-option>
				</el-select>
			</el-form-item>

			<el-form-item>
				<el-button size="small" type="primary" icon="el-icon-search" @click="initData">搜索</el-button>
			</el-form-item>
		</el-form> -->


	<div class="echart" id="mychartJCT" style="width:100%; height: 900px;"></div>
	<div class="echart" id="mychartJCTS" style="width:100%; height: 900px;margin-top: 50px;"></div>
	<div class="echart" id="mychartJCTL" style="width:100%; height: 900px;margin-top: 50px;"></div>
	<div class="echart" id="mychartJCTF" style="width:100%; height: 900px;margin-top: 50px;"></div>
	<div class="echart" id="mychartZLGQ" style="width:100%; height: 500px;margin-top: 50px;"></div>
	</div>
</template>
  
  <script>
  import * as echarts from "echarts";

  import {
	getAllSpotCodes,
	getAllFutureCodes,
	getBaseSubAnalysis,
	getBaseSubAnalysisZLGQ
	} from '../../api/basisMG.js'
  
  export default {
	data() {
	return {
		upcolor: "#FF0000", //增长颜色
		upBorderColor: "#8A0000",
		downColor: "#008000", // 下跌颜色
		downBorderColor: "#008F28",
		futureCodes:[],
		spotCodes:[],
		futureTypes:[],
		baseSubsDataT: [], 
		baseSubsDataTS: [], 
		baseSubsDataTL: [], 
		baseSubsDataTF: [], 
		baseSubsDataZLGQ:[],
		bldates:[]
	  };
	},
	methods: {
		getAllCodeTypes() {
				getAllFutureCodes().then(res => {
					if (res.code == '200') {
						this.futureCodes = res.data
					}
				})
				getAllSpotCodes().then(res => {
					if (res.code == '200') {
						this.spotCodes = res.data
					}
				})
			},


	  initData() {
		let param = this.formInline
		param.spotCode='230205.IB'
		param.futuresCode='T0'
		getBaseSubAnalysis(param).then(res => {
			this.saveParams(this.$route.path,param)
			if (res.code == '200') {
				this.baseSubs = res.data.baseSubs
				this.baseSubsDataT = this.splitData(this.baseSubs);
				this.initEchartsJC(this.baseSubsDataT,"mychartJCT","十","T");
			}
		});
		param.spotCode='230205.IB'
		param.futuresCode='TS0'
		getBaseSubAnalysis(param).then(res => {
			this.saveParams(this.$route.path,param)
			if (res.code == '200') {
				this.baseSubs = res.data.baseSubs
				this.baseSubsDataTS = this.splitData(this.baseSubs);
				this.initEchartsJC(this.baseSubsDataTS,"mychartJCTS","二","TS");
			}
		});
		param.spotCode='230205.IB'
		param.futuresCode='TL0'
		getBaseSubAnalysis(param).then(res => {
			this.saveParams(this.$route.path,param)
			if (res.code == '200') {
				this.baseSubs = res.data.baseSubs
				this.baseSubsDataTL = this.splitData(this.baseSubs);
				this.initEchartsJC(this.baseSubsDataTL,"mychartJCTL","三十","TL");
			}
		});
		param.spotCode='230205.IB'
		param.futuresCode='TF0'
		getBaseSubAnalysis(param).then(res => {
			this.saveParams(this.$route.path,param)
			if (res.code == '200') {
				this.baseSubs = res.data.baseSubs
				this.baseSubsDataTF = this.splitData(this.baseSubs);
				this.initEchartsJC(this.baseSubsDataTF,"mychartJCTF","五","TF");

			}
		});
		getBaseSubAnalysisZLGQ(param).then(res => {
			this.saveParams(this.$route.path,param)
			if (res.code == '200') {
				this.baseSubs = res.data.baseSubs
				this.baseSubsDataZLGQ = this.splitDataZLGQ(this.baseSubs);
				console.log("this.baseSubsDataZLGQ:",this.baseSubsDataZLGQ);
				this.initEchartsZLGQ();

			}
		});
		
	  },
	  initEchartsJC(data,chartname,year,futurename) {
		const optionT = {
		  title: {text:year+ "年期国债期货基差分析",left: 400},
		  tooltip: {trigger: "axis",axisPointer: {type: "cross"}},
		  legend: {data: ["基差","现货价格","主连",futurename+"2306",futurename+"2309"]},
		grid: [
			{x: '7%',y: '3%',height: '30%',left: '10%',bottom: '3%',gridIndex:0,text:'基差'},
			{x: '7%',y1: '3%',top:'35%',height: '30%',left: '10%',bottom: '3%',gridIndex:1},
			{x: '7%',y2: '3%',top:'65%',height: '30%',left: '10%',bottom: '3%',gridIndex:2}
		],
		xAxis: [
			{data: data.dates,gridIndex: 0, 
			type: "category",min: "dataMin",max: "dataMax",boundaryGap: false,show:true,
			axisLine: { onZero: false },splitLine: { show: false }},
			{data: data.dates,gridIndex: 1, 
			type: "category",min: "dataMin",max: "dataMax",boundaryGap: false,
			axisLine: { onZero: false },splitLine: { show: false }},
			{data: data.dates,gridIndex: 2, 
			type: "category",min: "dataMin",max: "dataMax",boundaryGap: false,
			axisLine: { onZero: false },splitLine: { show: false }}
		],
		yAxis: [
			{scale: true,gridIndex: 0,splitArea: { show: true}},
			{scale: true,gridIndex: 1,splitArea: { show: true}},
			{scale: true,gridIndex: 2,splitArea: { show: true}}
		],
		dataZoom: [
			{realtime: true,start: 80,end: 100,xAxisIndex: [0, 2],show: true},
			{realtime: true,start: 80,end: 100,xAxisIndex: [0, 1],type: 'inside'},
			{realtime: true,start: 80,end: 100,xAxisIndex: [0, 0],type: 'inside'}
		],
		series: [
			{name: "基差",type: "line",data: data.basesubvalues,smooth: true,showSymbol: false,lineStyle: {width: 1,opacity: 1},
			markLine: {data: [{ yAxis: 0, name: '0' }],symbol: ['none', 'none'], // 去掉箭头
            lineStyle: {type: 'solid',color: '#ff0000'}}},
			{name: "现货价格",type: "line",data: data.bcvalues,smooth: true,showSymbol: false,lineStyle: {width: 1,opacity: 1},xAxisIndex: 1,yAxisIndex: 1},
			{name: "主连",type: "line",data: data.qcvalues,smooth: true,showSymbol: false,lineStyle: {width: 1,opacity: 1},xAxisIndex: 1,yAxisIndex: 1},
			{name: futurename+"2306",type: "line",data: data.q1cvalues,smooth: true,showSymbol: false,lineStyle: {width: 1,opacity: 1},xAxisIndex: 2,yAxisIndex: 2},
			{name: futurename+"2309",type: "line",data: data.q2cvalues,smooth: true,showSymbol: false,lineStyle: {width: 1,opacity: 1},xAxisIndex: 2,yAxisIndex: 2}
		]
		};
		const myChartT = echarts.init(document.getElementById(chartname));
		myChartT.setOption(optionT);
		window.addEventListener("resize", () => {myChartT.resize();});
	  },
	  initEchartsZLGQ() {
		const optionT = {
		  title: {text:"各期主连分析",left: 400},
		  tooltip: {trigger: "axis",axisPointer: {type: "cross"}},
		  legend: {data: ["T2306","TS2306","TL2306","TF2306"]},
		grid: [
			{x: '7%',y: '3%',height: '90%',left: '10%',bottom: '3%',gridIndex:0,text:'基差'}
		],
		xAxis: [
			{data: this.baseSubsDataZLGQ.dates,gridIndex: 0, 
			type: "category",min: "dataMin",max: "dataMax",boundaryGap: false,show:true,
			axisLine: { onZero: false },splitLine: { show: false }}
		],
		yAxis: [
			{scale: true,gridIndex: 0,splitArea: { show: true}}
		],
		dataZoom: [
			{realtime: true,start: 95,end: 100,xAxisIndex: [0, 2],show: true}
		],
		series: [
			{name: "T2306", type: "line",data: this.baseSubsDataZLGQ.q1cvalues,smooth: true,showSymbol: false,lineStyle: {width: 1,opacity: 1}},
			{name: "TS2306",type: "line",data: this.baseSubsDataZLGQ.q2cvalues,smooth: true,showSymbol: false,lineStyle: {width: 1,opacity: 1}},
			{name: "TL2306",type: "line",data: this.baseSubsDataZLGQ.q3cvalues,smooth: true,showSymbol: false,lineStyle: {width: 1,opacity: 1}},
			{name: "TF2306",type: "line",data: this.baseSubsDataZLGQ.q4cvalues,smooth: true,showSymbol: false,lineStyle: {width: 1,opacity: 1}}
		]
		};
		const myChartT = echarts.init(document.getElementById("mychartZLGQ"));
		myChartT.setOption(optionT);
		window.addEventListener("resize", () => {myChartT.resize();});
	  },

	  // 数据计算以及拆分
	  splitData(rawData) {
		const dates = [];
		const bcvalues = [];
		const qcvalues = [];
		const q1cvalues = [];
		const q2cvalues = [];
		const basesubvalues = [];
		const markPointDatas=[];
		const msgs=[];
		for (let i = 0; i < rawData.length; i++) {
			dates.push(rawData[i].time);
			msgs.push(rawData[i].msg);
			bcvalues.push(rawData[i].bc);  
			qcvalues.push(rawData[i].qc);  
			q1cvalues.push(rawData[i].q1c);  
			q2cvalues.push(rawData[i].q2c);  
			basesubvalues.push(parseFloat(rawData[i].basesub).toFixed(4));  
			if (rawData[i].issame<1){  
				markPointDatas.push({value:'背',itemStyle: {color: 'rgb(41,60,85)'},coord: [rawData[i].time, 104]});
			}
		}
		return {
			dates: dates,
			bcvalues: bcvalues,
			qcvalues: qcvalues,
			q1cvalues: q1cvalues,
			q2cvalues: q2cvalues,
			basesubvalues: basesubvalues,
			markPointDatas:markPointDatas,
			msgs:msgs
		};
	  },
	  splitDataZLGQ(rawData) {
		console.log("rawData",rawData)
		const dates = [];
		const q1cvalues = [];
		const q2cvalues = [];
		const q3cvalues = [];
		const q4cvalues = [];
		for (let i = 0; i < rawData.length; i++) {
			dates.push(rawData[i].time);
			q1cvalues.push(rawData[i].q1c);  
			q2cvalues.push(rawData[i].q2c);  
			q3cvalues.push(rawData[i].q3c);  
			q4cvalues.push(rawData[i].q4c);  
		}
		return {
			dates: dates,
			q1cvalues: q1cvalues,
			q2cvalues: q2cvalues,
			q3cvalues: q3cvalues,
			q4cvalues: q4cvalues
		};
	},
	},
	mounted() {this.initData();},
	created() {this.getAllCodeTypes()},
  };
  </script>
  
  